import * as React from "react";
import {INotificationData} from "../types";

export const NotificationPublisherContext = React.createContext<(notificationData: INotificationData) => void>(
    () => {return;});
